import { useI18NextContext } from '@components/hooks';
import styled from '@emotion/styled';
import { mq } from '@styles/breakpoints';
import React from 'react';
import { Theme, ThemeProps } from '@theme/base';
import { Amount } from '@model/common';

export interface FromPriceProps {
  title: string;
  price?: Amount;
  label: string;
  theme?: Theme;
  className?: string;
}

const Price: any = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any),
  lineHeight: '2.2rem',
  flex: '1 0 auto',
  [mq.medium]: {
    margin: 0,
    marginBottom: theme.custom.spacing.xSmall,
    ...theme.custom.typography.h2,
    lineHeight: '4rem'
  }
}));

const Container: any = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  flexDirection: 'column',
  [mq.medium]: {
    marginBottom: theme.custom.spacing.medium,
    alignItems: 'flex-start'
  }
}));

const PriceContainer: any = styled.div({
  display: 'flex',
  alignItems: 'flex-end',
  lineHeight: '1.4rem',
  [mq.medium]: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
});

const Label = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  marginLeft: theme.custom.spacing.xSmall,
  textTransform: 'capitalize',
  [mq.medium]: {
    color: theme.custom.colors.group4.base,
    ...theme.custom.typography.paragraph,
    marginLeft: 0,
    textTransform: 'capitalize',
    fontWeight: '500'
  }
}));

const Title = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.labels.attribute as any),
  marginLeft: 0,
  color: theme.custom.colors.group4.base,
  textTransform: 'capitalize',
  marginBottom: theme.custom.spacing.xSmall,
  [mq.medium]: {
    marginRight: 0,
    ...theme.custom.typography.paragraph,
    fontWeight: '500'
  }
}));

export const FromPrice = ({ title, label, price, className }: FromPriceProps) => {
  const t: any = useI18NextContext();
  if (!price || !price.value) return null;
  return (
    <Container>
      <Title>{t(title)}</Title>
      <PriceContainer className={className}>
        <Price>{price.format()}</Price>
        <Label>{t(label)}</Label>
      </PriceContainer>
    </Container>
  );
};
